import React, { useCallback } from "react";
import DatePicker from "@ls/react-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { setSymbolicDate } from "state/selections/actions";
import SelectionState from "state/selections/SelectionState";
import {
  selectSelectedAsOfDate,
  selectSymbolicDate,
} from "state/selections/selectors";
import { setSelectedAsOfDate } from "state/selections/actions";

const AsOfDatePicker = () => {
  const dispatch = useDispatch();

  const selected = useSelector(
    selectSelectedAsOfDate(SelectionState.UNCOMMITTED)
  );
  const symbolicDate = useSelector(
    selectSymbolicDate(SelectionState.UNCOMMITTED)
  );
  
  const onChangeSymbolicDate = useCallback(
    (value) => dispatch(setSymbolicDate(value)),
    [dispatch]
  );

  const onChange = useCallback(
    (asOfDate) => {
      dispatch(setSelectedAsOfDate(asOfDate));
    },
    [dispatch]
  );

 
  return (
    <DatePicker
      onChange={onChange}
      selected={selected}
      onChangeSymbolicDate={onChangeSymbolicDate}
      symbolicDate={symbolicDate}
      variation={1}
      label="As of Date:"
      enableQuickSelect
      showMonthDropdown
      showYearDropdown
    />
  );
};

export default AsOfDatePicker;
